import { merge } from 'lodash-es'
import { computed } from 'vue'
import { createI18n } from 'vue-i18n'

class Translator {
  static i18n = null
  static storageKey = 'app_lang'

  static init(messages = {}, fallbackLocale = 'fr') {
    const savedLang = localStorage.getItem(Translator.storageKey)
    const browserLang = navigator.language?.split('-')[0] || fallbackLocale
    const initialLocale = savedLang || browserLang || fallbackLocale

    Translator.i18n = createI18n({
      legacy: false,
      globalInjection: false,
      locale: initialLocale,
      fallbackLocale,
      messages,
    })
  }

  static setLang(lang) {
    if (!Translator.i18n) throw new Error('Translator not initialized')
    Translator.i18n.global.locale.value = lang
    localStorage.setItem(Translator.storageKey, lang)
  }

  static getLang() {
    if (!Translator.i18n) throw new Error('Translator not initialized')
    return Translator.i18n.global.locale.value
  }

  // static translate(key, vars = {}) {
  //   if (!Translator.i18n) throw new Error('Translator not initialized')
  //   return Translator.i18n.global.t(key, vars)
  // }

  static $t = Translator.translate.bind(Translator)

  static translate(key, vars = {}, asComputed = true) {
    if (!Translator.i18n) throw new Error('Translator not initialized')
    if (asComputed) {
      return computed(() => Translator.i18n.global.t(key, vars))
    } else {
      return Translator.i18n.global.t(key, vars)
    }
  }

  static register(newMessages, namespace) {
    if (!Translator.i18n) throw new Error('Translator not initialized')

    for (const lang in newMessages) {
      const currentMessages =
        Translator.i18n.global.getLocaleMessage(lang) || {}
      const namespaceMessages = namespace
        ? { [namespace]: newMessages[lang] }
        : newMessages[lang]
      const merged = merge({}, currentMessages, namespaceMessages)
      Translator.i18n.global.setLocaleMessage(lang, merged)
    }
  }

  static install(app) {
    if (!Translator.i18n) throw new Error('Translator not initialized')

    // Lier $t au template et injecter dans app
    app.config.globalProperties.$t = Translator.translate.bind(Translator)
    // Optionnel : fournir l'instance i18n complète
    // app.use(Translator.i18n)
  }
}

export default Translator
export const $t = Translator.translate.bind(Translator)
